/* Core & libraries */
import React, { useEffect } from 'react'
import { FormattedMessage } from "react-intl";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import {ReactComponent as UploadIcon} from "../../../../../resources/images/upload-cloud-1.svg";

/* Styles */
import styles from "./styles";


const CustomInput = (props) => {
  const {
    className,
    labelClassName,
    labelWithFilesClassName,
    style,
    labelStyle,
    labelWithFilesStyle,
    getFilesFromEvent,
    accept,
    multiple,
    disabled,
    content,
    withFilesContent,
    onFiles,
    files,
  } = props

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <label
      className={classes.input}
      style={files.length > 0 ? labelWithFilesStyle : labelStyle}
    >
      <div className={classes.uploadIcon}>
        <UploadIcon />
      </div>
      <p><a><FormattedMessage id="admin.loyalty.bulkImportUploadLinkText"/></a> <FormattedMessage id="admin.loyalty.bulkImportUploadText"/></p>
      <p className={classes.csvText}><FormattedMessage id="admin.loyalty.bulkImportCsvText"/></p>
      <input
        className={className}
        style={style}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={async e => {
          const target = e.target
          const chosenFiles = await getFilesFromEvent(e)
          onFiles(chosenFiles)
          target.value = null
        }}
      />
    </label>
  )
}

export default CustomInput
